export default {
  // Page metadata
  'meta.title': 'شرایط خدمات - timer.today',
  'meta.description': 'شرایط خدمات و توافقنامه استفاده برای پلتفرم ابزارهای زمان‌سنجی آنلاین timer.today. در مورد قوانین خدمات، حقوق و مسئولیت‌های کاربران ما بیاموزید.',

  // Page header
  'page.title': 'شرایط خدمات',
  'page.lastUpdated': 'آخرین به‌روزرسانی: {{date}}',
  'page.intro': 'به timer.today خوش آمدید. این شرایط و ضوابط قوانین و مقررات استفاده از وب‌سایت timer.today را که در timer.today قرار دارد، مشخص می‌کند.',

  // Section 1
  'section1.title': '۱. پذیرش شرایط',
  'section1.content': 'با دسترسی و استفاده از این وب‌سایت، شما شرایط و مقررات این توافقنامه را می‌پذیرید و موافقت می‌کنید که به آنها پایبند باشید. اگر موافق نیستید که به موارد فوق پایبند باشید، لطفاً از این سرویس استفاده نکنید.',

  // Section 2
  'section2.title': '۲. توضیحات سرویس',
  'section2.intro': 'timer.today ابزارهای زمان‌سنجی رایگان آنلاین ارائه می‌دهد شامل:',
  'section2.timer': 'تایمر شمارش معکوس - تایمر قابل تنظیم برای بهره‌وری، آشپزی و مدیریت زمان',
  'section2.stopwatch': 'کرنومتر - ابزار زمان‌سنجی با دقت بالا برای ورزش، تمرین و زمان‌سنجی دقیق',
  'section2.worldclock': 'ساعت جهانی - نمایش لحظه‌ای مناطق زمانی جهانی',

  // Section 3
  'section3.title': '۳. مجوز استفاده',
  'section3.intro': 'اجازه استفاده موقت از timer.today فقط برای مشاهده شخصی و غیرتجاری اعطا می‌شود. این اعطای مجوز است، نه انتقال مالکیت، و تحت این مجوز شما نمی‌توانید:',
  'section3.item1': 'مطالب را تغییر دهید یا کپی کنید',
  'section3.item2': 'از مطالب برای هر هدف تجاری یا برای هر نمایش عمومی استفاده کنید',
  'section3.item3': 'سعی کنید نرم‌افزاری موجود در وب‌سایت را مهندسی معکوس کنید',
  'section3.item4': 'هرگونه حق نشر یا اطلاعیه‌های مالکیت دیگر را از مطالب حذف کنید',

  // Section 4
  'section4.title': '۴. حریم خصوصی و داده‌ها',
  'section4.intro': 'timer.today به حفاظت از حریم خصوصی شما متعهد است:',
  'section4.item1': 'ما اطلاعات شخصی جمع‌آوری یا ذخیره نمی‌کنیم',
  'section4.item2': 'تنظیمات تایمر به صورت محلی در مرورگر شما ذخیره می‌شود',
  'section4.item3': 'ما رفتار کاربر یا الگوهای استفاده را ردیابی نمی‌کنیم',
  'section4.item4': 'هیچ کوکی برای اهداف ردیابی استفاده نمی‌شود',

  // Section 5
  'section5.title': '۵. سلب مسئولیت',
  'section5.content': 'مطالب موجود در timer.today بر اساس "همان‌طور که هست" ارائه می‌شود. timer.today هیچ ضمانتی، صریح یا ضمنی، ارائه نمی‌دهد و بدین وسیله همه ضمانت‌های دیگر از جمله بدون محدودیت، ضمانت‌های ضمنی یا شرایط قابلیت فروش، مناسب بودن برای یک هدف خاص، یا عدم نقض مالکیت معنوی یا سایر نقض حقوق را رد می‌کند و منتفی می‌داند.',

  // Section 6
  'section6.title': '۶. محدودیت‌ها',
  'section6.content': 'در هیچ صورت timer.today یا تامین‌کنندگان آن مسئول هرگونه خسارت (از جمله، بدون محدودیت، خسارات ناشی از از دست دادن داده‌ها یا سود، یا به دلیل وقفه کسب و کار) ناشی از استفاده یا ناتوانی در استفاده از مطالب موجود در timer.today نخواهند بود، حتی اگر timer.today یا نماینده مجاز آن به صورت شفاهی یا کتبی از احتمال چنین خساراتی مطلع شده باشد.',

  // Section 7
  'section7.title': '۷. دقت مطالب',
  'section7.content': 'مطالب ظاهر شده در timer.today ممکن است شامل اشتباهات فنی، تایپی یا عکاسی باشد. timer.today تضمین نمی‌کند که هیچ یک از مطالب موجود در وب‌سایت آن دقیق، کامل یا جاری باشد. timer.today ممکن است در هر زمان بدون اطلاع قبلی تغییراتی در مطالب موجود در وب‌سایت خود ایجاد کند.',

  // Section 8
  'section8.title': '۸. تغییرات',
  'section8.content': 'timer.today ممکن است در هر زمان بدون اطلاع قبلی این شرایط خدمات را برای وب‌سایت خود تجدیدنظر کند. با استفاده از این وب‌سایت، شما موافقت می‌کنید که به نسخه فعلی این شرایط خدمات پایبند باشید.',

  // Section 9
  'section9.title': '۹. اطلاعات تماس',
  'section9.intro': 'اگر سؤالی در مورد این شرایط خدمات دارید، لطفاً با ما تماس بگیرید:',
  'section9.email': 'ایمیل:',
  'section9.emailSubject': 'استعلام شرایط خدمات - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. تمامی حقوق محفوظ است.'
};
